import React, { useRef, useEffect } from 'react';

import { IconCloseSmall, IconGlobe } from '@lessonnine/design-system.lib';
import InputFrame from './InputFrame';

import { t } from 'src/viewLayer/helpers/translations';

export default ({
  clearValue,
  disabled,
  errorKey,
  isFocused,
  setFocus,
  onChangeHandler,
  value
}) => {
  const IdentityProviderInputRef = useRef();

  useEffect(() => {
    if (isFocused) IdentityProviderInputRef.current.focus();
  }, [isFocused]);

  return (
    <InputFrame errorKey={errorKey} disabled={disabled} focused={isFocused}>
      <div className="icon-globe">
        <IconGlobe/>
      </div>
      <input
        id="uat-identityprovider-input-field"
        className="input-field"
        type="text"
        placeholder={ t('login.b2b.identity_provider_placeholder') }
        value={value}
        autoComplete="subdomain"
        name="identityprovider"
        onChange={onChangeHandler}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        ref={IdentityProviderInputRef}
        disabled={disabled}
      />
      <span className="prefilled">.babbel.com</span>
      <div
        className={'icon-end-right ' + (value ? '' : 'hidden')}
        onClick={clearValue}
        disabled={disabled}
      >
        <IconCloseSmall />
      </div>
    </InputFrame>
  );
};
